import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { HiringBensScreenComponent } from './HiringBensScreen.types'
import { useHiringBensScreen } from './useHiringBensScreen'

const HiringBensScreenDesktop = lazy(() => import('./HiringBensScreen.desktop'))

const HiringBensScreenMobile = lazy(() => import('./HiringBensScreen.mobile'))

export const HiringBensScreen: HiringBensScreenComponent = ({ navigation, route }) => {
  const props = useHiringBensScreen({ navigation, route })

  const Screen = props.isMobile ? HiringBensScreenMobile : HiringBensScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
